import { Fieldset } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { Center } from "#shared/view/components/Center";
import { Button } from "#shared/view/designSystem/Button";

interface onCompanyChoiceProps {
  onCreateNewCompanyClick: () => void;
  onJoinExistingCompanyClick: () => void;
}

export function CompanyChoice({
  onCreateNewCompanyClick,
  onJoinExistingCompanyClick,
}: onCompanyChoiceProps) {
  const styles = {
    fieldset: {
      borderBottom: "none",
      borderLeft: "none",
      borderRight: "none",
      color: "#4675f5",
      borderColor: "#4675f5",
      marginTop: "50px",
    },
    button: {
      color: "#4675f5",
      borderColor: "#4675f5",
    },
  };

  const { t } = useTranslation();

  return (
    <form style={{ minWidth: 400 }}>
      <Center>
        <Button
          style={styles.button}
          mt="xs"
          variant="outline"
          size="xl"
          radius="xs"
          onClick={onCreateNewCompanyClick}
        >
          {t("login.iCreateNewCompany")}
        </Button>
      </Center>
      <Center>
        <Fieldset style={styles.fieldset} radius="0" legend="OU" />
      </Center>
      <Center>
        <Button
          style={styles.button}
          variant="outline"
          size="xl"
          radius="xs"
          onClick={onJoinExistingCompanyClick}
        >
          {t("login.joinExistingCompany")}
        </Button>
      </Center>
    </form>
  );
}
